/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Applicant
 */
export interface Applicant {
    /**
     * 
     * @type {Date}
     * @memberof Applicant
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Applicant
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof Applicant
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof Applicant
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Applicant
     */
    state: ApplicantStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApplicantStateEnum {
    Active = 'active',
    Hidden = 'hidden',
    Deleted = 'deleted'
}

export function ApplicantFromJSON(json: any): Applicant {
    return ApplicantFromJSONTyped(json, false);
}

export function ApplicantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Applicant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'email': json['email'],
        'state': json['state'],
    };
}

export function ApplicantToJSON(value?: Applicant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'email': value.email,
        'state': value.state,
    };
}


